var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteDigiSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 94,
    viewBox: "0 0 118 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.573326 38.1899C0.573326 42.953 1.4453 47.5124 3.03834 51.7173C2.98183 51.5952 2.92547 51.4726 2.8692 51.3492C4.30646 58.6101 11.9855 75.0471 31.2036 82.7075C31.9503 82.9688 33.3203 83.1554 32.8276 81.8115C32.2946 80.5618 31.2369 77.6041 31.2044 75.6318C33.6478 76.1224 36.1754 76.3798 38.7632 76.3798C59.8549 76.3798 76.9531 59.2816 76.9531 38.1899C76.9531 17.0982 59.8549 0 38.7632 0C17.6715 0 0.573326 17.0982 0.573326 38.1899Z",
    fill: "#7DB8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.779 66.6543C117.174 62.9724 117.937 58.9799 117.937 54.8091C117.937 36.3437 102.968 21.3745 84.5029 21.3745C66.0375 21.3745 51.0684 36.3437 51.0684 54.8091C51.0684 73.2744 66.0375 88.2436 84.5029 88.2436C86.7685 88.2436 88.9815 88.0183 91.1207 87.5887C91.0923 89.3154 90.1663 91.9048 89.6997 92.9989C89.2683 94.1755 90.4677 94.0121 91.1214 93.7833C107.947 87.0768 114.669 72.6865 115.928 66.3297C115.878 66.4385 115.828 66.5467 115.779 66.6543ZM104.636 81.5047C104.315 81.7469 103.99 81.9835 103.661 82.2143C103.984 81.9904 104.309 81.7541 104.636 81.5047Z",
    fill: "#7DB8F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDigiSmall);
export default __webpack_public_path__ + "static/media/white-digi-small.73ce491b3064e358e06375e4652dd32e.svg";
export { ForwardRef as ReactComponent };